import { useUnsavedChanges } from 'hooks'

const withUnsavedChanges = Component => {
  const UnsavedChanges = props => {
    const { isPristine, saveChanges } = props
    useUnsavedChanges(!isPristine, saveChanges)

    return <Component {...props} />
  }

  return UnsavedChanges
}

export default withUnsavedChanges
